var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":_vm.name || _vm.id}},[_c('input',{ref:_vm.checkboxRef,staticClass:"input-type--checkbox",attrs:{"id":_vm.id,"type":"checkbox","name":_vm.name || _vm.id},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.onClick($event)}}}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }